const options = {
    autoHeight: true,
    grabCursor: true,
    keyboard: true,
    navigation: {
        prevEl: '.js-slider-partner-teaser-prev',
        nextEl: '.js-slider-partner-teaser-next',
        disabledClass: 'button--disabled',
    },
    spaceBetween: 24,
    slidesPerView: 'auto',
};

const sliderPartnerTeaser = {
    init() {
        const elements = document.querySelectorAll('.js-slider-partner-teaser');

        if (!elements.length) return;

        elements.forEach((element) => {
            const {autoplay, loop, speed} = element.dataset;
            if (autoplay === '1') {
                options.autoplay = {delay: 200, disableOnInteraction: false};
                options.speed = speed > 0 ? speed : 2000;
            }

            if (loop === '1') {
                options.loop = true;
            }

            const Slider = slider.default;
            this.sliderTestimonials = new Slider(element, options);
        });
    },
};

export default sliderPartnerTeaser;
